import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      paddingRight: 32,
    },
    searchFormControl: {},
    table: {
      display: 'flex',
      '& th:first-child': {
        borderTopLeftRadius: 15,
      },
      '& th:last-child': {
        borderTopRightRadius: 15,
      },
      '& tr:last-child ': {
        '& td:first-child': { borderBottomLeftRadius: 15 },
        '& td:last-child': { borderBottomRightRadius: 15 },
      },
      '& tr td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
      '& tr th:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
      '& tr td + td': {
        borderTop: '2px solid #E1E8ED',
        borderBottom: '2px solid #E1E8ED',
      },
      padding: '30px 15px',
      '& table': {
        borderRadius: 15,
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '15px 15px 0px 0px',
      },
      '& thead th': {
        innerWidth: 132,
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: '8px 0px 8px 40px',
      },
      '& tbody tr > *': {
        padding: theme.spacing(0, 5),
      },

      '& td': {
        borderBottom: 'none',
        padding: '16px 0px 16px 40px',
        '&:first-child': {
          padding: 0,
          '& > div': {
            padding: '0px 0px 0px 40px',
          },
        },
        '&:last-child': {
          padding: '16px 8px 16px 40px',
        },
      },
    },
    date: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: -20,
      marginLeft: 15,
    },
    resumeContainer: {
      padding: theme.spacing(1),
    },
    cardCount: {
      display: 'flex',
      background: '#ddd9',
      padding: '10px 15px !important',
      marginBottom: 10,
      borderRadius: 7,
    },
    marginRight: {
      marginRight: theme.spacing(1.5),
    },
    primaryAmount1: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
    primaryAmount2: {
      color: '#1CBA27',
      fontWeight: 'bold',
    },
    primaryAmount3: {
      color: '#666',
      fontWeight: 'bold',
    },
    secondaryAmount: {
      marginTop: -5,
      color: '#777',
    },

    sortLabel: {
      color: '#fff !important',
    },
    resume: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 70,
      height: 42,
      marginRight: 5,
      padding: 7,
      border: '1px solid #14171A',
      borderRadius: 10,
    },
    contentImage: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 16,
      maxHeight: 16,
      height: '100%',
      marginRight: 5,
    },
    dividerVertical: {
      '&:fist-child': {
        background: '#fff',
      },
      background: '#14171A',
      marginRight: 8,
      marginTop: 1,
    },
    subTiltle: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 700,
      fontSize: 8,
      color: ' #14171A',
      lineHeight: 1,
    },
    value: {
      fontSize: 12,
      color: ' #14171A',
      lineHeight: 1,
    },
    contentTotalEntry: {
      display: 'grid',
      marginRight: 8,
    },
  }),
);

export default useStyles;
